import { render, staticRenderFns } from "./StudentCompletion.vue?vue&type=template&id=efef55ae&scoped=true&"
import script from "./StudentCompletion.vue?vue&type=script&lang=js&"
export * from "./StudentCompletion.vue?vue&type=script&lang=js&"
import style0 from "./StudentCompletion.vue?vue&type=style&index=0&id=efef55ae&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efef55ae",
  null
  
)

export default component.exports